import { render, staticRenderFns } from "./DonutChartSchool.vue?vue&type=template&id=a465f816&scoped=true&"
import script from "./DonutChartSchool.vue?vue&type=script&lang=js&"
export * from "./DonutChartSchool.vue?vue&type=script&lang=js&"
import style0 from "./DonutChartSchool.vue?vue&type=style&index=0&id=a465f816&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a465f816",
  null
  
)

export default component.exports